<template>
    <div id="customerAROutstanding">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>

        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Customer Aged Trial Balance Summary</div>
                    <div class="web-action-btn btn-groups text-right">
                        <!-- Button for Clear Cache -->
                        <!-- <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data> -->
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                            <i class="fp-export"></i> Export
                        </a>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content customer-ar-report">
                        <data-table-filter-config :moduleName="'customerAgedTrialBalance'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'customerAgedTrialBalance'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="CustomerAgedTrialBalance"
                                    mode="remote"
                                    title="Customer Aged Trial Balance"
                                    @on-page-change="onPageChange"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    @on-select-all="onSelectAll"
                                    @on-selected-rows-change="selectionChanged"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                        enabled: true,
                                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                        selectionInfoClass: 'custom-class',
                                        selectionText: 'rows selected',
                                        clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">
                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'notes'">
                                                <span v-fp-html="props.formattedRow[props.column.field]"></span>
                                            </div>
                                            <!-- Value format is from backend-->
                                            <!-- <div v-else-if="props.column.field == 'pct_of_credit'">
                                                {{ amountFormat(getNum(props.formattedRow[props.column.field])) }} %
                                            </div>
                                            <div v-else-if="props.column.field == 'period_1'|| props.column.field == 'period_2'
                                            || props.column.field == 'period_3' || props.column.field == 'period_4'
                                            || props.column.field == 'period_5' || props.column.field == 'available_credit'
                                            || props.column.field == 'net_ar_balance' || props.column.field == 'total_overdue'
                                            || props.column.field == 'credit_limit' || props.column.field == 'ar_balance'
                                            || props.column.field == 'on_account'">
                                                {{ amountFormat(getNum(props.formattedRow[props.column.field])) }}
                                            </div> -->
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';

let msgServer;
export default {
    name: "CustomerAgedTrialBalanceSummary",
    metaInfo() {
        return {
            title: "Customer Aged Trial Balance Summary | " +process.env.COPYRIGHT_NAME
        }
    },
    mixins:[commonMixins,dataTableMixins],
    data: () => ({
        pageKey:"_CustomerAgedTrialBalanceReport_",
        batchProcess:0,
        batchNum:"",
        firstLoad: 0,
        permissions: [],
        cantAccessPage: "",
        userColumns:[],
        columns: [
            {
                label:'Customer Name',
                field:'customer_name',
                fpFieldType:"text",
                filterable:true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Customer Name", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label:'Customer Number',
                field:'customer_code',
                fpFieldType:"text",
                filterable:true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Customer Number", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label:'Credit Limit',
                field:'credit_limit',
                fpFieldType:"integer",
                filterable: true,
                hidden:false,
                type:'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Credit Limit", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label:'Net AR Balance',
                field:'net_ar_balance',
                fpFieldType:"integer",
                filterable: false,
                hidden:false,
                type:'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Net AR Balance", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:false
            },
            {
                label:'Pct of Credit',
                field:'pct_of_credit',
                fpFieldType:"integer",
                filterable: false,
                hidden:false,
                type:'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Pct of Credit", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:false
            },
            {
                label:'AR Balance',
                field:'ar_balance',
                fpFieldType:"integer",
                filterable: true,
                hidden:false,
                type:'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "AR Balance", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:true
            },
            {
                label:'On Account',
                field:'on_account',
                fpFieldType:"integer",
                filterable: false,
                hidden:false,
                type:'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "On Account", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:false
            },
            {
                label:'Total Overdue',
                field:'total_overdue',
                fpFieldType:"integer",
                filterable: true,
                hidden:false,
                type:'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Total Overdue", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:true
            },
            {
                label:'Available Credit',
                field:'available_credit',
                fpFieldType:"integer",
                filterable: false,
                hidden:false,
                type:'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Total Overdue", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:false
            },
            {
                label:'Hold Code',
                field:'hold_code',
                fpFieldType:"text",
                filterable:false,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Hold Code", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:false
            },
            {
                label:'Current',
                field:'current',
                fpFieldType:"text",
                filterable:false,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Current", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:false
            },
            {
                label:'1-30',
                field:'period_1',
                fpFieldType:"integer",
                filterable: true,
                hidden:false,
                type:'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "1-30", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:true
            },
            {
                label:'31-60',
                field:'period_2',
                fpFieldType:"integer",
                filterable: true,
                hidden:false,
                type:'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "31-60", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:true
            },
            {
                label:'61-90',
                field:'period_3',
                fpFieldType:"integer",
                filterable: true,
                hidden:false,
                type:'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "61-90", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:true
            },
            {
                label:'91+',
                field:'period_4',
                fpFieldType:"integer",
                filterable: true,
                hidden:false,
                type:'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "91+", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:true
            },
            {
                label:'120+',
                field:'period_5',
                fpFieldType:"integer",
                filterable: true,
                hidden:false,
                type:'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "120+", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:true
            },
            {
                label:'Avg Days',
                field:'average_days',
                fpFieldType:"integer",
                filterable: true,
                hidden:false,
                // type:'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Avg Days", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label:'Review Credit',
                field:'review_credit',
                fpFieldType:"text",
                filterable:false,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Review Credit", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:false
            },
            {
                label:'Phone Number',
                field:'phone_no',
                fpFieldType:"text",
                filterable:true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Phone Number", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label:'Fax',
                field:'fax_no',
                fpFieldType:"text",
                filterable:true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Fax", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label:'Credit Manager',
                field:'credit_manager',
                fpFieldType:"text",
                filterable:true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Credit Manager", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label:'Salesperson',
                field:'sales_person',
                fpFieldType:"text",
                filterable:true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Salesperson", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label:'Facility',
                field:'facility',
                fpFieldType:"option",
                filterable:true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Facility", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label:'Pmt Terms',
                field:'pmt_terms',
                fpFieldType:"text",
                filterable:true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Pmt Terms", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label:'Customer Type',
                field:'customer_type',
                fpFieldType:"text",
                filterable:true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Customer Type", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label:'Order Type',
                field:'order_type',
                fpFieldType:"text",
                filterable:false,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Order Type", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:false
            },
            {
                label: 'Note Date',
                field: 'activity_time',
                filterable: true,
                fpFieldType:"custom_date",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "MM/DD/YYYY", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label:'Note Author',
                field:'note_author',
                fpFieldType:"text",
                filterable:true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Note Author", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label:'Note Header',
                field:'subject',
                fpFieldType:"text",
                filterable:true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Note Header", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label:'Note Comments',
                field:'notes',
                fpFieldType:"text",
                filterable:true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Note Comments", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
             {
                label:'Summarize',
                field:'summary',
                fpFieldType:"option",
                filterable:false,
                hidden:true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Note Comments", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: ['Yes','No'],
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:false
            },
        ],
        rows: [],
        totalRecords: 0,
        loading:false,
        action:'list'
    }),
    watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'customer_aged_trial_balance_summary_report') {
                        self.cantAccessPage = true;
                    }
                }
            }
        },
    },
    created: function() {
        this.serverParams.stopRequest = true;
    },
    beforeDestroy() {
        // Make sure to close the connection with the events server
        // when the component is destroyed, or we'll have ghost connections!
        msgServer.close();
    },
    mounted: function() {
        var self = this;

        self.getPermissions();
    },
    methods: {
        cancelAll: function (cancelAll) {
          this.$refs.CustomerAgedTrialBalance.unselectAllInternal();
        },
        loadList: function() {

            var self = this;

            var selectedRows = [];
            var data = this.$refs['CustomerAgedTrialBalance'].selectedRows;
            for ( var i = 0; i < data.length; i++ ) {
                selectedRows.push(this.$refs['CustomerAgedTrialBalance'].selectedRows[i].id)
            }

            var fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                action:self.action,
                selectedAll:self.serverParams.selectedAll,
                selectedRows:selectedRows,
            };

            self.firstLoad = 1;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/report/customer-aged-trial-balance-summary",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {

                      if ( self.action == "export" ||  self.action == "export_queue") {

                            if ( data.code == "201" ) {
                                alert(data.message);
                            } else {

                                if ( self.action == "export" ) {

                                    self.excel = data.content.web;
                                    var save = document.createElement("a");
                                    save.href = self.excel;
                                    save.download = data.content.web;
                                    save.target = "_blank";

                                    document.body.appendChild(save);
                                    save.click();
                                    document.body.removeChild(save);

                                } else {

                                    self.batchProcess = 1;
                                    self.batchNum = data.content;
                                }

                            }

                            self.action = "list";
                            self.loadList();
                            return;

                      } else {
                          self.rows = data.content.row;
                          self.totalRecords = data.content.totalRecords;
                      }

                      /*
                        if (self.action =='export'){
                          self.action = 'list';
                          if ( data.code == "201" ) {
                              alert(data.message);
                          } else {

                              var excel = data.content.web;
                              var save = document.createElement("a");
                              save.href = excel;
                              save.download = data.content.web;
                              save.target = "_blank";

                              document.body.appendChild(save);
                              save.click();
                              document.body.removeChild(save);
                              self.cancelAll(true);
                          }
                          self.loadList();
                        } else {
                          self.rows = data.content.row;
                          self.totalRecords = data.content.totalRecords;
                        }
                      */
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'customer-aged-trial-balance')
                }
            });
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/reports/CustomerAgedTrialBalanceSummary.vue